module.exports = __webpack_public_path__ + "static/media/136-iran.d2ad7f2f.svg";